import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { totalBonuses, totalVolumes } from '../data/offer';
export function GuaranteeSection() {
  return <section className="bg-stage py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-94" data-mp="9ttgc9z21wy4">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-95" data-mp="et66p4p4xm5g">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border-2 border-forest bg-white p-8 shadow-card sm:p-12" data-id="element-96" data-mp="eur20wj9x94d">
          <span className="inline-flex rounded-full bg-forest p-4 text-goldBright" data-id="element-97" data-mp="smxea7jb2vyj">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-98" data-mp="xj5pj9udu50f" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold text-forestDeep" data-id="element-99" data-mp="12klaz30h2djc">
            Complete 7-day guarantee
          </h2>
          <p className="mt-4 leading-relaxed text-inkSoft" data-id="element-100" data-mp="25rx6qgm90hvt">
            Open all {totalVolumes} volumes. Review all {totalBonuses} bonuses. Use them in your most challenging
            surveying class this week. If you feel your students didn't respond better or the materials didn't save you
            hours of work:
          </p>
          <p className="mt-6 rounded-lg border-l-4 border-gold bg-beige px-5 py-4 text-lg font-extrabold text-forestDeep" data-id="element-101" data-mp="1rt7b75f2uq9k">
            We refund 100% of your money. No questions. No forms. No complications.
          </p>
          <p className="mt-5 text-sm leading-relaxed text-inkSoft" data-id="element-102" data-mp="2jjvbkf8xfrm6">
            Because if this teacher ready doesn't deliver the value we promise, we don't want to keep your money.
          </p>
        </motion.div>
      </div>
    </section>;
}